import api from "@/lib/api";

const SOURCE_KEY = "trilogy_source";

// Event type constants (kept in sync with backend TRACK_TYPES)
export const EVENT = {
  PAGEVIEW: "pageview",
  FORM_SUBMIT: "form_submit",
  LEAD_SUBMIT: "lead_submit",
  BOOKING_CLICK: "booking_click",
  PACKAGE_CLICK: "package_click",
  APP_DOWNLOAD_CLICK: "app_download_click",
  CONTACT_CLICK: "contact_click",
  EVENT_REGISTRATION_CLICK: "event_registration_click",
  LOGIN_CLICK: "login_click",
  SUPPORT_TICKET_SUBMIT: "support_ticket_submit",
};

// Dev-only debug logger so non-critical failures aren't fully silent while staying quiet in prod
const _devWarn = (scope, e) => { if (process.env.NODE_ENV === "development") console.debug(`[track:${scope}]`, e); };

// Capture the lead/traffic source from UTM params once per session
export function captureSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get("utm_source") || params.get("source") || params.get("ref") || "").toLowerCase().trim();
    if (raw && !sessionStorage.getItem(SOURCE_KEY)) sessionStorage.setItem(SOURCE_KEY, raw);
  } catch (e) { _devWarn("captureSource", e); }
}

export function getSource() {
  try { return sessionStorage.getItem(SOURCE_KEY) || ""; } catch (e) { _devWarn("getSource", e); return ""; }
}

// Fire a tracking event: stored first-party + forwarded to GA4 / Meta Pixel if present
export function track(type, label = "", meta = {}) {
  const path = (typeof window !== "undefined" && window.location.pathname) || "";
  const source = getSource();
  try { if (window.gtag) window.gtag("event", type, { event_label: label, ...meta }); } catch (e) { _devWarn("gtag", e); }
  try { if (window.fbq) window.fbq("trackCustom", type, { label, ...meta }); } catch (e) { _devWarn("fbq", e); }
  api.post("/track", { type, label, path, source, meta }).catch((e) => _devWarn("post", e));
}
